import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Typography } from '@mui/material';
import { Box } from '@mui/system';
import General from '../Profile/General';
import Education from '../Profile/Education';
import WorkExperience from '../Profile/WorkExperience';
import { enqueueSnackbar } from 'notistack';
import Navbar from '../../Navbar';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../assets/Layout';

const CreateProfile = () => {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("user")) {
            navigate('/')
        }
    }, [])

    return (
        <Layout>
            <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'center', mt: 12, mb: 2 }}>Create Profile</Typography>
            <Tabs value={selectedTab} indicatorColor="#2544EE"
                sx={{
                    mx:{md:10 , xs:0},
                    '& .MuiTabs-indicator': {
                        backgroundColor: '#2544EE',
                    },
                }}>
                <Tab label="General"
                    sx={{
                        fontWeight: '600',

                        color: '#2544EE',
                        '&.Mui-selected': {
                            color: '#2544EE',
                        },
                    }}

                />
                <Tab label="Education"
                    sx={{
                        fontWeight: '600',

                        color: '#2544EE',
                        '&.Mui-selected': {
                            color: '#2544EE',
                        },
                    }}
                />

                <Tab label="Work Experince" sx={{
                    color: '#2544EE',
                    fontWeight: '600',

                    '&.Mui-selected': {
                        color: '#2544EE',
                    },
                }} />
            </Tabs>

            {selectedTab === 0 && (
                <Box sx={{ p:{md: '16px', xs:'0px'} }}>
                    <General setSelectedTab={setSelectedTab} />
                </Box>
            )}

            {selectedTab === 1 && (
                <Box sx={{ p:{md: '16px', xs:'0px'} }}>
                    <Education setSelectedTab={setSelectedTab} />
                </Box>
            )}

            {selectedTab === 2 && (
                <Box sx={{ p:{md: '16px', xs:'0px'} }}>
                    <WorkExperience />
                </Box>
            )}
        </Layout>
    );
};

export default CreateProfile;
